/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React from 'react';

import './link.scss';

const link = require('b_').with('common-link');

export const Link = ({ title, href, mod }) => (
    <a className={link(mod)} href={href} rel="noreferrer" target="_blank">{title}</a>
);
